module.exports = __webpack_public_path__ + "media/images/category-biosphere-da52679077d41c8aedb45df658f6fe4d.jpg";